/* eslint-disable @typescript-eslint/no-explicit-any */
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { IconArrowLeft } from '@tabler/icons';
import { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

const headerSX = {
	'& .MuiCardHeader-action': { mr: 0 },
};

const MainCard = forwardRef(
	(
		{
			border = true,
			boxShadow = true,
			backBtn = false,
			backPath = '',
			children,
			content = true,
			contentClass = '',
			contentSX = {},
			darkTitle,
			secondary,
			shadow,
			sx = {},
			title,
			pageTitle,
			noPageTitle = false,
			...others
		}: any,
		ref,
	) => {
		const theme = useTheme();
		const navigate = useNavigate();
		const handleBackBtn = () => {
			navigate(backPath.length > 0 ? backPath : -1);
		};
		return (
			<Card
				ref={ref}
				{...others}
				sx={{
					border: border ? '1px solid' : 'none',
					borderColor: theme.palette.grey[200],
					...sx,
				}}
			>
				{!noPageTitle && (
					<Helmet>
						<title>{pageTitle || title}</title>
					</Helmet>
				)}

				{title && (
					<CardHeader
						avatar={
							backBtn && (
								<IconButton onClick={handleBackBtn}>
									<IconArrowLeft />
								</IconButton>
							)
						}
						sx={headerSX}
						title={title}
						action={secondary}
					/>
				)}

				{title && <Divider sx={{ width: '95%', mx: 'auto' }} />}

				{content && (
					<CardContent sx={contentSX} className={contentClass}>
						{children}
					</CardContent>
				)}
				{!content && children}
			</Card>
		);
	},
);

export default MainCard;
